var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLoop = function SvgIconLoop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899 -942)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(899 982) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1966.7,6530.708l-3.606-3.605a11.874,11.874,0,0,1-7.726,2.829,11.886,11.886,0,0,1-8.462-3.506,11.882,11.882,0,0,1-3.5-8.461,11.882,11.882,0,0,1,3.5-8.46,11.887,11.887,0,0,1,8.462-3.5,11.886,11.886,0,0,1,8.46,3.5,11.883,11.883,0,0,1,3.5,8.46,11.871,11.871,0,0,1-2.828,7.728l3.6,3.605a1,1,0,0,1,0,1.411.992.992,0,0,1-.7.292A.992.992,0,0,1-1966.7,6530.708Zm-21.3-12.744a9.982,9.982,0,0,0,9.972,9.972,9.982,9.982,0,0,0,9.97-9.972,9.982,9.982,0,0,0-9.97-9.972A9.982,9.982,0,0,0-1988.005,6517.965Zm8.973,3.99v-2.991h-2.991a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2.991v-2.992a1,1,0,0,1,1-1,1,1,0,0,1,1,1v2.992h2.991a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-2.991v2.991a1,1,0,0,1-1,1A1,1,0,0,1-1979.032,6521.955Z",
    transform: "translate(2897.001 -5556)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-loop.f3a5a1cd.svg";
export { ForwardRef as ReactComponent };